module.exports = __webpack_public_path__ + "static/media/apple.24e8bddd.svg";